import { supabase } from "./supabase";
import { marcar } from "./rastreio";

export interface WaitlistEntry {
  id: number;
  name: string;
  email: string;
  whatsapp: string | null;
  country_code: string | null;
  member_id: number | null;
  source: string;
  status: string;
  created_at: string;
  notified_at: string | null;
}

export function normalizeEmail(email: string): string {
  return (email || "").trim().toLowerCase().replace(/\s+/g, "");
}

export type JoinWaitlistResult = { status: "created" } | { status: "already" };

export interface JoinWaitlistInput {
  name: string;
  email: string;
  whatsapp?: string;
  countryCode?: string | null;
}

// Grava o interesse na lista de espera. Toda a lógica (normalização de
// e-mail/telefone, vínculo com membro e antidup) roda no servidor pela função
// RPC `join_waitlist`, então o navegador NÃO lê event_waitlist nem members
// diretamente — as tabelas ficam livres pra serem trancadas depois.
export async function joinWaitlist(
  input: JoinWaitlistInput,
): Promise<JoinWaitlistResult> {
  const { data, error } = await supabase.rpc("join_waitlist", {
    p_name: input.name || "",
    p_email: input.email || "",
    p_whatsapp: input.whatsapp || "",
    p_country_code: input.countryCode || "",
  });

  if (error) throw error;

  // A função devolve "novo" (inseriu) ou "atualizado" (já existia).
  const status = (data as { status?: string } | null)?.status;
  marcar("ListaDeEspera", true);
  return status === "atualizado" ? { status: "already" } : { status: "created" };
}

// Vínculo retroativo: quando alguém da lista vira membro depois, liga pelo
// e-mail. Usado APENAS pelo admin autenticado (não pelo caminho público).
export async function linkWaitlistByEmail(
  memberId: number | string,
  email: string,
): Promise<void> {
  const id = Number(memberId);
  const normalizedEmail = normalizeEmail(email);
  if (!id || !normalizedEmail) return;

  const { data } = await supabase
    .from("event_waitlist")
    .select("id, email")
    .ilike("email", normalizedEmail)
    .limit(100);

  if (!data?.length) return;

  const ids = (data as { id: number; email: string }[])
    .filter((e) => normalizeEmail(e.email) === normalizedEmail)
    .map((e) => e.id);

  if (ids.length === 0) return;

  await supabase
    .from("event_waitlist")
    .update({ member_id: id, source: "membro" })
    .in("id", ids);
}